export const API_ENDPOINTS = {
    getConfig: '/config',
    INSPECTION: {
        INSPECTIONS: 'inspections',
        SYNC: 'inspections/sync',
    },
    META: {
        CLIENT_DECISIONS: 'meta/client-decisions',
        CONTROL_POINTS: 'meta/control-points',
        DEFECT_CATEGORIES: 'meta/defects',
        DIVISIONS: 'meta/divisions',
        STATUS: 'meta/inspection-statuses',
        LEVELS: 'meta/inspection-levels',
        IMAGE_CATEGORIES: 'meta/image-categories',
    },
    FILE: {
        GET_URL: 'files/generate-upload-url',
        UPLOAD: 'files/upload'
    },
    AUTH: {
        LOGIN: 'auth/login',
        LOGOUT: 'auth/logout'
    },
    LOGS: {
        LOGS: 'logs'
    }
};
